import { TelemetryEvent, trackEvent } from './telemetry';

function describeTarget(target: EventTarget | null): { url: string; kind: string } | null {
	if (target instanceof HTMLScriptElement) {
		return { url: target.src, kind: 'script' };
	}
	if (target instanceof HTMLLinkElement) {
		return { url: target.href, kind: 'stylesheet' };
	}
	if (target instanceof HTMLImageElement) {
		return { url: target.src, kind: 'image' };
	}
	return null;
}

const MAX_REPORTS_PER_SESSION = 50;

/**
 * Reports assets that fail to load. The host pulls a dozen remote micro-frontend bundles plus
 * the Google Maps script from other origins; when one of those 404s or times out the browser
 * fires a resource error that does NOT surface as a JS exception, so Faro's error
 * instrumentation never saw it and an MF simply went missing with no signal.
 *
 * The listener is registered in the capture phase because resource errors do not bubble.
 */
export default function instrumentAssets(): void {
	let reported = 0;

	window.addEventListener(
		'error',
		(event) => {
			const target = describeTarget(event.target);
			if (!target || !target.url) {
				return;
			}

			reported += 1;
			if (reported > MAX_REPORTS_PER_SESSION) {
				return;
			}

			trackEvent(TelemetryEvent.AssetLoadFailed, {
				kind: target.kind,
				url: target.url.split('?')[0],
				truncatedAfter: reported === MAX_REPORTS_PER_SESSION ? MAX_REPORTS_PER_SESSION : undefined,
			});
		},
		true,
	);
}
